import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { getStaffLandingPath } from "@/lib/page-permissions";

export default function NoStaffPages() {
  const { user, logout } = useAuth();
  const destination = getStaffLandingPath(user);
  if (destination !== "/staff/no-pages") return <Navigate to={destination} replace />;
  return (
    <main className="min-h-screen flex items-center justify-center p-6" style={{ background: "var(--fb-bg)" }}>
      <section className="fb-card max-w-lg p-8" data-testid="no-staff-pages">
        <h1 className="text-2xl font-bold mb-3">No pages available</h1>
        <p role="status" className="mb-6">
          Your staff account does not have access to any pages. Please contact an administrator to update your page access.
        </p>
        <button type="button" className="fb-btn-primary px-4 py-3 rounded-lg" onClick={logout}>Sign out</button>
      </section>
    </main>
  );
}
